import React, { Component } from 'react';
// import {Link,Redirect,withRouter} from "react-router-dom";
// import {connect} from "react-redux"
// import {signup} from "../../../store/actions/user/User"

class SignUp extends Component {
  render() {
    return <></>;
  }
}
// const mapStateToProps = (state) => {
//     // console.log(state);
//     return {
//       auth: state.user.auth
//     };
//   };

// const mapDispatchToProps = (dispatch) => {
//   // console.log(dispatch);
//   return {
//     signup: (creds) => dispatch(signup(creds)),
//   };
// };
export default SignUp;
